import { Link, Typography } from "@mui/material";
import { Links, SystemStatus } from "src/constants";
import { FeedItemDto, FeedItemUserValueDto } from "src/http";

interface Props {
  feedItem: FeedItemDto;
}

const RoleUserPropertyChange = (props: Props) => {
  const value = props.feedItem.propertyChange!.value as FeedItemUserValueDto;

  if ([SystemStatus.Created, SystemStatus.Edited].includes(props.feedItem.propertyChange!.changeType)) {
    return (
      <Typography variant="caption">
        <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
        <span> added </span>
        <strong>
          <Link href={Links.User(value.userId)}>{value.displayName}</Link>
        </strong>
        <span> to the role</span>
      </Typography>
    );
  }

  if (props.feedItem.propertyChange!.changeType === SystemStatus.Deleted) {
    return (
      <Typography variant="caption">
        <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
        <span> removed </span>
        <strong>
          <Link href={Links.User(value.userId)}>{value.displayName}</Link>
        </strong>
        <span> from the role</span>
      </Typography>
    );
  }

  return null;
};

export { RoleUserPropertyChange };
